import { lazy } from 'react'
import AuthRoute from './authentication'

// ** Document title
const TemplateTitle = '%s - AVDHAAN'

// ** Default Route
const DefaultRoute = '/all-project'

// if (localStorage.getItem('userData')) {
//   const navigation = JSON.parse(localStorage.getItem('userData')).access
// } else {
// }

// ** Merge Routes
const AcessRoutes = [
  ...AuthRoute,
  {
    path: '/all-project',
    component: lazy(() => import('../../pages/allProject'))
  },
  {
    path: '/user-access-panel',
    component: lazy(() => import('../../pages/userPanel'))
  },
  {
    path: '/project-access-panel',
    component: lazy(() => import('../../pages/projectPanel'))
  },
  {
    path: '/admin',
    component: lazy(() => import('../../pages/userAcessPanel'))
  },
  {
    path: '/admin-panel',
    component: lazy(() => import('../../pages/adminPanel'))
  },
  // Account-level, not a project module: the bell is in the app chrome on every
  // screen, so the feed it opens can't hang off `/:project/:module`.
  {
    path: '/notifications',
    component: lazy(() => import('../../pages/Notifications'))
  },
  // {
  //   path: '/:category/:project/:module/:pss',
  //   component: lazy(() => import('../../views/module'))
  // },,

  {
    path: '/:project/:module',
    component: lazy(() => import('../../pages'))
  },
  {
    path: '/:project/:module/maps/:mapType',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/Maps/MapsWrapper'))
  },
  {
    path: '/:project/:module/rtc',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/RTC'))
  },
  {
    path: '/:category/:project/:module',
    component: lazy(() => import('../../pages'))
  },
  {
    path: '/:category/:project/:module/maps/:mapType',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/Maps/MapsWrapper'))
  },
  {
    path: '/:category/:project/:module/rtc',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/RTC'))
  },
  // HES meter profile detail. The list/tab routes (`/:project/:module/push-data`,
  // `/:project/:module/meter-profile`) need no entry of their own — they already
  // match `/:category/:project/:module` above, and `getRouteContext` resolves the
  // project/module from the path. Only the deeper detail route is unmatched.
  {
    path: '/:project/:module/meter-profile/:meterId',
    component: lazy(() => import('../../pages/GasDistribution/module/Hes/MeterProfile/MeterProfileDetail'))
  },
  // Per-tab URL, so every section of the meter detail page is deep-linkable.
  // A bare `/meter-profile/:meterId` redirects here with the default tab.
  {
    path: '/:project/:module/meter-profile/:meterId/:tab',
    component: lazy(() => import('../../pages/GasDistribution/module/Hes/MeterProfile/MeterProfileDetail'))
  },
  // Legacy four-segment form, kept so existing bookmarks and stored default
  // routes still resolve.
  {
    path: '/:category/:project/:module/meter-profile/:meterId',
    component: lazy(() => import('../../pages/GasDistribution/module/Hes/MeterProfile/MeterProfileDetail'))
  },
  {
    path: '/:category/:project/:module/push-data',
    component: lazy(() => import('../../pages'))
  },
  {
    path: '/:category/:project/:module/meter-profile',
    component: lazy(() => import('../../pages'))
  },
  // {
  //   path: '/:category/:project',
  //   component: lazy(() => import('../../views/project'))
  // },
  {
    path: '/error',
    component: lazy(() => import('../../components/CustomComponent/error')),
    layout: 'BlankLayout'
  },
  {
    path: '/no',
    component: lazy(() => import('../../components/CustomComponent/notAuthorised')),
    layout: 'BlankLayout'
  }
]

export { DefaultRoute, TemplateTitle, AcessRoutes }
